import { createInjectionKey } from "../../_utils/index.mjs";
export const timePickerInjectionKey = createInjectionKey('n-time-picker');